import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../axiosApi';

const initialState = {};

export const callHistoryGet = createAsyncThunk('report/call_history', async (params) => {
  return await apiInstance.get('/cdrs_report/call_history', { params });
});

export const liveCallHistoryGet = createAsyncThunk('report/live-call_history', async (params) => {
  return await apiInstance.get('/crm-history/', { params });
});

export const agentMissedCallReportGet = createAsyncThunk(
  'report/agent-missed-call-report',
  async (params) => {
    return await apiInstance.get('/missed-call-report/agent-missed-call-report/', { params });
  }
);

// Agent side of the 360 details report: every call of the number in the company, not
// only the agent's own calls.
export const agentThreeSixtyReportGet = createAsyncThunk(
  'report/360-report/agent',
  async (params) => {
    return await apiInstance.get('/360-report/agent', { params });
  }
);

export const agentThreeSixtyReportDetailsGet = createAsyncThunk(
  'report/360-report/agent/details',
  async (params) => {
    return await apiInstance.get('/360-report/agent/details', { params });
  }
);

const callHistorySlice = createSlice({
  name: 'callHistory',
  initialState,
  reducers: {
    clearCallHistorySlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default callHistorySlice.reducer;
export const { clearCallHistorySlice } = callHistorySlice.actions;
